import { useState, useEffect } from "react";
import moment from "moment-timezone";
import {
  Grid,
  Typography,
  List,
  Divider,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Button,
  Chip,
} from "@mui/material";
import ReleaseDetails from "./ReleaseDetails";
import request from "../../../utilities/requests";

const ReleaseNotes = () => {
  const [notes, setNotes] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async (page) => {
    const result = await request(`releasenotes?page=${page}`);
    if (result.success) {
      if (page > 1) {
        // const n = notes.concat(result.notes);
        // setNotes([...n]);
        setNotes((prevNotes) => [...prevNotes, ...result.notes]);
      } else {
        setNotes(result.notes);
      }
      setPage(result.page);
      setHasMore(result.hasMore);
    }
  };

  const formatDate = (d) => {
    const userTimezone = moment.tz.guess(); // e.g., "America/Los_Angeles"

    const formatted = moment.tz(d, userTimezone).format("YYYY-MM-DD");
    return formatted;
  };

  const renderTopics = (topics) => {
    if (!topics) return null;

    return (
      <div style={{ display: "flex", gap: 5 }}>
        {topics.map((t) => {
          return <Chip key={`chip-${t}`} label={t} size="small" />;
        })}
      </div>
    );
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ padding: 20 }}
      direction="column"
      spacing={3}
    >
      <Grid item>
        <Typography variant="h4" align="center">
          Release Notes
        </Typography>
      </Grid>
      <Grid item>
        <Typography align="center">
          Review the latest functionality as it is released
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3}>
          <List>
            {notes.map((d) => {
              return (
                <>
                  <ListItem>
                    <ListItemButton
                      onClick={() => {
                        setSelectedNote(d);
                        setDialogOpen(true);
                      }}
                    >
                      <ListItemText
                        primary={d.summary}
                        secondary={`${formatDate(d.releaseDate)} || ${d.key}`}
                      />
                      {renderTopics(d.topics)}
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </>
              );
            })}
          </List>
        </Paper>
      </Grid>
      {hasMore ? (
        <Grid item>
          <Button onClick={() => getData(page + 1)}>Show more</Button>
        </Grid>
      ) : null}
      <ReleaseDetails
        open={dialogOpen}
        close={() => {
          setDialogOpen(false);
          setSelectedNote(null);
        }}
        note={selectedNote}
      />
    </Grid>
  );
};

export default ReleaseNotes;
